import { useState } from 'react';
import type { ReactElement } from 'react';

import errorLogger from '@picsart/growth-rc/services/errorLogger';
import { ReactINTLProvider } from '@picsart/rc/services/localization';
import type { ILanguagesCodes } from '@picsart/rc/types/data/languages';
import { createGenerateId, JssProvider, SheetsRegistry } from 'react-jss';

import useMount from '@/hooks/useMount';
import useOpen from '@/hooks/useOpen';
import { getContext, isContextAvailable } from '@/miniappContext';

const registry = new SheetsRegistry();
const generateId = createGenerateId({
  minify: import.meta.env.MODE === 'production',
});

function JSSProviderWrapper({ children }: { children: ReactElement }) {
  return (
    <JssProvider generateId={generateId} registry={registry}>
      {children}
    </JssProvider>
  );
}

export default function Providers({ children }: { children: ReactElement }) {
  const [language, setLanguage] = useState<ILanguagesCodes>(isContextAvailable() ? (getContext().general.language.getState() as ILanguagesCodes) : 'en');

  useMount(() => {
    if (!isContextAvailable()) return;
    getContext().general.language.subscribe((nextLanguage: ILanguagesCodes) => setLanguage(nextLanguage));
  });

  const isOpen = useOpen(() => {
    errorLogger.leaveBreadcrumb('opening the miniapp now', {
      category: isOpen,
    });
  });

  return (
    <ReactINTLProvider projectName="pa_miniapps" language={language} withoutReusableComponents>
      <JSSProviderWrapper>{children}</JSSProviderWrapper>
    </ReactINTLProvider>
  );
}
